var ROUTES = {
  HOME: "ola-home",
  INSURANCE: "ola-insurance",
  COVID_HUB: "ola-covid-hub",
  COVID_HUB_ROUTES: "ola-covid-hub-routes",
  AUTO_ONLINE_BOOKING: "ola-auto-online-booking",
  DONATION: "ola-donation",
  RSA: "ola-rsa",
  BETA_LAUNCH: "ola-beta-launch",
  BETA_LAUNCH_IN: "ola-beta-launch-in",
  FEEDBACK: "ola-feedback",
  FEEDBACK_ALT: "ola-feedback_alt",
  CARDS_PAYMENT: "ola-card-payments",
  VELOCITY: "ola-velocity",
  VELOCITY_KM: "ola-velocity-km",
  DISCOUNT_VOUCHERS: "ola-discount-vouchers",
  FAQ: "ola-faq-page",
  AUTO_SHARE_OTP: "ola-auto-share-otp",
  TRACK_RIDE: "ola-track-ride",
  RATE_CARD: "ola-app-site-rate-card",
  DETAILS: "ola-category-detail",
  DRIVER_STORIES: "ola-driver-stories",
  ONDC: "ondc-landing",
  OFFLINE_AUTO: "offline-auto",
  OLA_COINS: "ola-coins",
  OLA_COINS_TRANSACTION_HISTORY: "ola-coins-transaction-history",
  OLA_COINS_FAQ: "ola-coins-faq",
  OLA_COINS_TOU: "ola-coins-tou",
  ADDRESS_MAP:"address-map",
  TRACKING_DETAILS:"tracking-details",
};

var router = new VueRouter({
  mode: 'history', //to set it to html5mode, other value can be 'hash' for hashband method
  base: window.owConfig.assetsPath, //this is needed in html5mode to calculate relative url
  routes: [
    {
      name: ROUTES.HOME,
      path: '/',
      component: function (resolve) {
        owLazyRoute(ROUTES.HOME, resolve);
      }
    },
    {
      name: ROUTES.INSURANCE,
      path: '/insurance',
      component: function (resolve) {
        owLazyRoute(ROUTES.INSURANCE, resolve);
      }
    },
    {
      name: ROUTES.COVID_HUB,
      path: '/consumer-ola-hub',
      component: function (resolve) {
        owLazyRoute(ROUTES.COVID_HUB, resolve);
      }
    },
    {
      name: ROUTES.COVID_HUB_ROUTES,
      path: '/consumer-ola-hub-routes',
      component: function (resolve) {
        owLazyRoute(ROUTES.COVID_HUB_ROUTES, resolve);
      }
    },
    {
      name: ROUTES.AUTO_ONLINE_BOOKING,
      path: '/auto-online-booking',
      component: function (resolve) {
        owLazyRoute(ROUTES.AUTO_ONLINE_BOOKING, resolve);
      }
    },
    {
      name: ROUTES.AUTO_SHARE_OTP,
      path: '/auto-share-otp',
      component: function (resolve) {
        owLazyRoute(ROUTES.AUTO_SHARE_OTP, resolve);
      }
    },
    {
      name: ROUTES.DONATION,
      path: '/donation',
      component: function (resolve) {
        owLazyRoute(ROUTES.DONATION, resolve);
      }
    },
    {
      name: ROUTES.RSA,
      path: '/rsa',
      component: function (resolve) {
        owLazyRoute(ROUTES.RSA, resolve);
      }
    },
    {
      name: ROUTES.BETA_LAUNCH,
      path: '/beta-launch',
      component: function (resolve) {
        owLazyRoute(ROUTES.BETA_LAUNCH, resolve);
      }
    },
    {
      name: ROUTES.BETA_LAUNCH_IN,
      path: '/beta-launch-in',
      component: function (resolve) {
        owLazyRoute(ROUTES.BETA_LAUNCH_IN, resolve);
      }
    },
    {
      name: ROUTES.FEEDBACK,
      path: '/feedback',
      component: function (resolve) {
        owLazyRoute(ROUTES.FEEDBACK, resolve);
      }
    },
    {
      name: ROUTES.FEEDBACK_ALT,
      path: "/feedback-alt",
      component: function (resolve) {
        owLazyRoute(ROUTES.FEEDBACK_ALT, resolve);
      }
    },
    {
      name: ROUTES.CARDS_PAYMENT,
      path: '/card-payments',
      component: function (resolve) {
        owLazyRoute(ROUTES.CARDS_PAYMENT, resolve);
      }
    },
    {
      name: ROUTES.VELOCITY,
      path: '/velocity',
      component: function (resolve) {
        owLazyRoute(ROUTES.VELOCITY, resolve);
      }
    },
    {
      name: ROUTES.VELOCITY_KM,
      path: '/velocity/know-more',
      component: function (resolve) {
        owLazyRoute(ROUTES.VELOCITY_KM, resolve);
      }
    },
    {
      name: ROUTES.DISCOUNT_VOUCHERS,
      path: '/discount-vouchers',
      component: function (resolve) {
        owLazyRoute(ROUTES.DISCOUNT_VOUCHERS, resolve);
      }
    },
    {
      name: ROUTES.FAQ,
      path: '/faq',
      component: function (resolve) {
        owLazyRoute(ROUTES.FAQ, resolve);
      }
    },
    {
      name: ROUTES.TRACK_RIDE,
      path: '/track/:bookingid',
      component: function (resolve) {
        owLazyRoute(ROUTES.TRACK_RIDE, resolve);
      }
    },
    {
      name: ROUTES.RATE_CARD,
      path: '/rate-card',
      component: function (resolve) {
        owLazyRoute(ROUTES.RATE_CARD, resolve);
      }
    },
    {
      name: ROUTES.DRIVER_STORIES,
      path: '/driver-stories',
      component: function (resolve) {
        owLazyRoute(ROUTES.DRIVER_STORIES, resolve);
      }
    },
    {
      name: ROUTES.ONDC,
      path: '/ondc',
      component: function (resolve) {
        owLazyRoute(ROUTES.ONDC, resolve);
      }
    },
    {
      name: ROUTES.ONDC,
      path: '/ondcgrocery',
      component: function (resolve) {
        owLazyRoute(ROUTES.ONDC, resolve);
      }
    },
    {
      name: ROUTES.OFFLINE_AUTO,
      path: '/offline-auto',
      component: function (resolve) {
        owLazyRoute(ROUTES.OFFLINE_AUTO, resolve);
      }
    },
    {
      name: ROUTES.OLA_COINS,
      path: '/ola-coins',
      component: function (resolve) {
        owLazyRoute(ROUTES.OLA_COINS, resolve);
      }
    },
    {
      name: ROUTES.OLA_COINS_TRANSACTION_HISTORY,
      path: '/ola-coins-transaction-history',
      component: function (resolve) {
        owLazyRoute(ROUTES.OLA_COINS_TRANSACTION_HISTORY, resolve);
      }
    },
    {
      name: ROUTES.OLA_COINS_FAQ,
      path: '/ola-coins-faq',
      component: function (resolve) {
        owLazyRoute(ROUTES.OLA_COINS_FAQ, resolve);
      }
    },
    {
      name: ROUTES.OLA_COINS_TOU,
      path: '/ola-coins-tou',
      component: function (resolve) {
        owLazyRoute(ROUTES.OLA_COINS_TOU, resolve);
      }
    },
    {
      name: ROUTES.ADDRESS_MAP,
      path: '/address-map',
      component: function (resolve) {
        owLazyRoute(ROUTES.ADDRESS_MAP, resolve);
      }
    },
    {
      name: ROUTES.TRACKING_DETAILS,
      path: '/tracking-details',
      component: function (resolve) {
        owLazyRoute(ROUTES.TRACKING_DETAILS, resolve)
      }
    },

    // Adding a new route? Add before this line

    {
      name: ROUTES.DETAILS,
      path: '/:category',
      component: function (resolve) {
        owLazyRoute(ROUTES.DETAILS, resolve);
      }
    },
    {
      path: '/*',
      redirect: {
        name: ROUTES.HOME
      }
    }
  ]
});

let initialized = false;

router.beforeEach((to, from, next) => {
  // if (to.matched.some(m => m.meta.preload)) {
    let vueDummy = new Vue();
    let {
      loadCommonComponents,
      loadHomeComponents,
      loadInsuranceComponents,
      loadCovidHubComponents,
      loadAutoBookingComponents,
      loadDonationComponents,
      loadRSAComponents,
      loadBetaLaunchComponents,
      loadFeedbackComponents,
      loadCardsPaymentComponents,
      loadVelocityComponents,
      loadDiscountVouchersComponents,
      loadFAQComponents,
      loadTrackRideComponents,
      loadRateCardComponents,
      loadDetailsComponents,
      loadDriverStoriesComponents,
      loadONDCComponents,
      loadOfflineAutoComponents,
      loadOlaCoinsComponents,
      loadOlaCoinsTransactionHistoryComponents,
      loadOlaCoinsFaqComponents,
      loadOlaCoinsTouComponents,
      loadAddressMapComponents,
      loadTrackingDetailsComponents
    } = vueDummy;
    if (!initialized) {
      loadCommonComponents();
      initialized = true;
    }
    switch (to.name) {
      case ROUTES.HOME: {
        loadHomeComponents();
        break;
      }
      case ROUTES.INSURANCE: {
        loadInsuranceComponents();
        break;
      }
      case ROUTES.COVID_HUB: {
        loadCovidHubComponents();
        break;
      }
      case ROUTES.COVID_HUB_ROUTES: {
        loadCovidHubComponents();
        break;
      }
      case ROUTES.AUTO_ONLINE_BOOKING: {
        loadAutoBookingComponents();
        break;
      }
      case ROUTES.AUTO_SHARE_OTP: {
        loadAutoBookingComponents();
        break;
      }
      case ROUTES.DONATION: {
        loadDonationComponents();
        break;
      }
      case ROUTES.RSA: {
        loadRSAComponents();
        break;
      }
      case ROUTES.BETA_LAUNCH: {
        loadBetaLaunchComponents();
        break;
      }
      case ROUTES.BETA_LAUNCH_IN: {
        loadBetaLaunchComponents();
        break;
      }
      case ROUTES.FEEDBACK: {
        loadFeedbackComponents();
        break;
      }
      case ROUTES.FEEDBACK_ALT: {
        loadFeedbackComponents();
        break;
      }
      case ROUTES.CARDS_PAYMENT: {
        loadCardsPaymentComponents();
        break;
      }
      case ROUTES.VELOCITY: {
        loadVelocityComponents();
        break;
      }
      case ROUTES.VELOCITY_KM: {
        loadVelocityComponents();
        break;
      }
      case ROUTES.DISCOUNT_VOUCHERS: {
        loadDiscountVouchersComponents();
        break;
      }
      case ROUTES.FAQ: {
        loadFAQComponents();
        break;
      }
      case ROUTES.TRACK_RIDE: {
        loadTrackRideComponents();
        break;
      }
      case ROUTES.RATE_CARD: {
        loadRateCardComponents();
        break;
      }
      case ROUTES.DETAILS: {
        loadDetailsComponents();
        break;
      }
      case ROUTES.DRIVER_STORIES: {
        loadDriverStoriesComponents();
      }
      case ROUTES.ONDC: {
        loadONDCComponents();
      }
      case ROUTES.OFFLINE_AUTO: {
        loadOfflineAutoComponents();
      }
      case ROUTES.OLA_COINS: {
        loadOlaCoinsComponents();
      }
      case ROUTES.OLA_COINS_TRANSACTION_HISTORY: {
        loadOlaCoinsTransactionHistoryComponents();
      }
      case ROUTES.OLA_COINS_FAQ: {
        loadOlaCoinsFaqComponents();
      }
      case ROUTES.OLA_COINS_TOU: {
        loadOlaCoinsTouComponents();
      }
      case ROUTES.ADDRESS_MAP: {
        loadAddressMapComponents();
      }
      case ROUTES.TRACKING_DETAILS: {
        loadTrackingDetailsComponents();
      }
    }
  // }
  next();
});